import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useLocation } from "react-router-dom";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import drilldown from "highcharts/modules/drilldown.js";
import HighchartsExporting from "highcharts/modules/exporting";
import "../Style/chart.css";
import { BsArrowLeft } from "react-icons/bs";

drilldown(Highcharts);
HighchartsExporting(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

export default function AppHighchart({ data }) {
  if (!data) {
    return <div>Loading chart data...</div>;
  }
  const options = {
    title: {
      text: data.indicator_name,

      style: {
        fontWeight: "bold",
        color: "#fff",
      },
    },

    subtitle: {
      text: data.sub_title,
      style: {
        color: "#9699a2",
      },
    },
    credits: {
      position: {
        y: -5,
      },
      href: "#",
      text: "Kilde: " + data.origin,
      style: {
        color: "#fff",
      },
    },

    legend: isMobile
      ? {
          enabled: false,
        }
      : {
          maxHeight: 80,
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
          itemMarginTop: 2,
          itemMarginBottom: 2,
          itemStyle: {
            textOverflow: "clip",
            color: "#fff",
            fontWeight: "bold",
          },

          borderWidth: 1,

          borderRadius: 3,

          itemHoverStyle: {
            color: "#ff0000",
          },

          itemHiddenStyle: {
            color: "#9699a2",
          },
        },

    tooltip: {
      // Sort by value, unless indicator is "Samlet vekstfaktor"
      formatter:
        data.indicator_id !== "0"
          ? function () {
              const chart = this;
              return `<b>${chart.points[0].key}</b><br />${chart.points
                .sort((pointA, pointB) => pointB.y - pointA.y)
                .map((point) => {
                  return `<span style="color: ${point.color}">\u25CF</span> ${point.series.name}: ${point.y.toLocaleString("no")}`;
                })
                .join("<br />")}`;
            }
          : undefined,
      shared: true,
      split: false,
      outside: false,
      backgroundColor: "#000",
      style: {
        color: "#fff",
      },
      borderColor: "black",
      borderRadius: 5,
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        lineWidth: isMobile ? 1 : 2,
        cursor: "pointer",
        marker: {
          enabled: true,
          radius: isMobile ? 2 : 3,
          states: {
            hover: {
              enabled: true,
              radius: isMobile ? 3 : 4,
            },
          },
        },
      },
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.y}", // Shows name and raw y value (no percentage)
          style: {
            color: "#fff",
            fontWeight: "bold",
          },
        },
        showInLegend: true,
      },
    },

    navigation: {
      buttonOptions: {
        symbolStroke: "#fff",
        x: -50,

        theme: {
          fill: "#353535",
        },
      },
    },

    exporting: {
      menuItemDefinitions: {
        downloadCSV: { text: "DOWNLOAD EXCEL (CSV)" },
        downloadXLS: { text: "DOWNLOAD EXCEL (XLS)" },
      },
    },

    chart: {
      type: "line",
      backgroundColor: "#353535",
      zoomType: "x",
      events: {
        drilldown: function (e) {
          this.setTitle({ text: data.indicator_name + " - " + e.point.name });
          //Add logic here if we need to change y-axis title on drilldown
          //this.yAxis[0].setTitle({ text: data.yAxisTitle });
          // Find the drilldown series to get its yAxisTitle
          const drilldownSeries = data.graphdata?.seriesDrilldown?.find(
            (series) => series.id === e.seriesOptions?.id
          );
          
          const yAxisTitle = drilldownSeries?.yAxisTitle || data.yAxisTitleDrilldown;
          this.yAxis[0].setTitle({ text: yAxisTitle });
        },
        drillup: function (e) {
          e?.point?.name === undefined
            ? this.setTitle({ text: data.indicator_name })
            : this.setTitle({
                text: data.indicator_name + " - " + e.point.name,
              });
          this.yAxis[0].setTitle({ text: data.yAxisTitle });
        },
      },
    },

    xAxis: {
      id: "xAxis",

      type: "category",

      labels: {
        style: {
          color: "#fff",
        },
      },
      lineColor: "#fff",

      tickColor: "#fff",
      title: {
        text: "",
        style: {
          color: "#fff",
        },
      },
      plotLines: [
        {
          events: {
            click: function () {
              console.log("x-axis drilldown");
            },
          },
        },
      ],
    },
    yAxis: {
      id: "yAxis",
      opposite: false,
      gridLineWidth: 0.2,
      crosshair: true,
      accessibility: {
        description: data.yAxisTitle ? data.yAxisTitle : "Y-akse",
        rangeDescription: data.yAxisTitle ? data.yAxisTitle : "",
        enabled: true,
      },
      labels: {
        formatter: function () {
          return this.value.toLocaleString("no-NO");
        },
        style: {
          color: "#fff",
        },
      },
      lineColor: "#fff",

      tickColor: "#fff",
      title: {
        text: data.yAxisTitle ? data.yAxisTitle : "Y-akse",
        style: {
          color: "#fff",
        },
      },
    },
    series: data.graphdata?.series,
    drilldown: {
      activeAxisLabelStyle: {
        color: "#add8e6",
      },

      series: data.graphdata?.seriesDrilldown,

      breadcrumbs: {
        showFullPath: false,
      },
    },
  };

  //TODO: removal would be best.
  return (
    <div style={{ position: "relative", height: "100%" }}>
      {data.indicator_id !== "0" ? (
        <div
          style={{
            position: "absolute",
            top: "0.5em",
            left: "0.5em",
            color: "white",
            border: "0px solid pink",
            zIndex: "1",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => window.history.back()}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "center",
            }}
          >
            <BsArrowLeft style={{ height: "20px", width: "75px" }} />
            <p>Forrige indikator</p>
          </div>
        </div>
      ) : null}
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        containerProps={{ style: { height: "100%", zIndex: "3" } }}
        immutable={true}
      />
    </div>
  );
}
